import { render, staticRenderFns } from "./Finance.vue?vue&type=template&id=04642f50&"
import script from "./Finance.vue?vue&type=script&lang=js&"
export * from "./Finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04642f50')) {
      api.createRecord('04642f50', component.options)
    } else {
      api.reload('04642f50', component.options)
    }
    module.hot.accept("./Finance.vue?vue&type=template&id=04642f50&", function () {
      api.rerender('04642f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/dashboard/Finance.vue"
export default component.exports